import { Component, inject } from "@angular/core";
import { MatBottomSheetRef } from "@angular/material/bottom-sheet";
import { BottomMenuSheetItemComponent } from "../bottom-menu-sheet-item/bottom-menu-sheet-item.component";
import { RouterLink, RouterLinkActive } from "@angular/router";

@Component({
	selector: "app-bottom-menu-internal-view-more-items",
	imports: [BottomMenuSheetItemComponent, RouterLink, RouterLinkActive],
	templateUrl: "./bottom-menu-internal-view-more-items.component.html",
})
export class BottomMenuInternalViewMoreItemsComponent {
	private bottomSheet = inject(MatBottomSheetRef);

	close(): void {
		this.bottomSheet.dismiss();
	}
}
